import React from 'react'
import {CardBox, CardTitle, Divider} from '../BaseCard/styles'
import EditIcon from '../../../../images/icons/new-dashboard/calendar-edit-icon.svg'
import {
  ReportLinkBox,
  CardText,
  CardContent,
  IconBox,
  StatusBox,
  DaysBox,
  RiskText,
  BehindText,
  TrackText,
  AheadText,
} from './styles'
import {Attempt} from '../../../../redux/reportExamStatus'
import {Link} from 'react-router-dom'

import StatusAhead from '../../../../images/icons/new-dashboard/status-ahead.svg'
import StatusAtRisk from '../../../../images/icons/new-dashboard/status-at-risk.svg'
import StatusOnTrack from '../../../../images/icons/new-dashboard/status-on-track.svg'
import StatusBehind from '../../../../images/icons/new-dashboard/status-behind.svg'
import InformationIcon from '../../../../images/icons/new-dashboard/information-icon.svg'
import {TooltipBox, WhiteTooltip} from '../../DivisionProgress/styles'

type Props = {
  report?: Attempt
  division: string
  expectedDay: number
  currentDay: number
}

const View = ({report, division, expectedDay, currentDay}: Props) => {
  const renderStatus = () => {
    if (currentDay > expectedDay) {
      return (
        <StatusBox>
          <img src={StatusAhead} alt="Ahead of Schedule" />{' '}
          <AheadText>Ahead of Schedule</AheadText>
          <WhiteTooltip
            title={
              <TooltipBox>
                <b>Ahead of Schedule</b>
                <span>
                  You're progressing faster than planned! This means you're
                  completing tasks ahead of your study schedule, giving you
                  extra flexibility.
                </span>
              </TooltipBox>
            }
            arrow
          >
            <img src={InformationIcon} alt="Ahead of Schedule" />
          </WhiteTooltip>
        </StatusBox>
      )
    }

    if (currentDay === expectedDay) {
      return (
        <StatusBox>
          <img src={StatusOnTrack} alt="On Track" />{' '}
          <TrackText>On Track</TrackText>
          <WhiteTooltip
            title={
              <TooltipBox>
                <b>On Track</b>
                <span>
                  You're right where you need to be! Keep up the steady progress
                  to stay on schedule and reach your goal on time.
                </span>
              </TooltipBox>
            }
            arrow
          >
            <img src={InformationIcon} alt="On Track" />
          </WhiteTooltip>
        </StatusBox>
      )
    }

    if (expectedDay - currentDay <= 3) {
      return (
        <StatusBox>
          <img src={StatusBehind} alt="Slightly Behind" />{' '}
          <BehindText>Slightly Behind</BehindText>
          <WhiteTooltip
            title={
              <TooltipBox>
                <b>Slightly Behind</b>
                <span>
                  You're just a little off track. A small adjustment to your
                  study pace will help you catch up and stay on course.
                </span>
              </TooltipBox>
            }
            arrow
          >
            <img src={InformationIcon} alt="Slightly Behind" />
          </WhiteTooltip>
        </StatusBox>
      )
    }

    if (expectedDay - currentDay > 3) {
      return (
        <StatusBox>
          <img src={StatusAtRisk} alt="At Risk" /> <RiskText>At Risk</RiskText>
          <WhiteTooltip
            title={
              <TooltipBox>
                <b>At Risk</b>
                <span>
                  You're falling behind your study plan. Consider adjusting your
                  schedule or increasing your study time to get back on track.
                </span>
              </TooltipBox>
            }
            arrow
          >
            <img src={InformationIcon} alt="At Risk" />
          </WhiteTooltip>
        </StatusBox>
      )
    }
  }

  const renderMessage = () => {
    if (report) {
      const date = new Date(report.examDate)
      date.setHours(date.getHours() + 12)
      const displayDate = date.toLocaleDateString('en-US')

      const examDate = new Date(report.examDate)
      examDate.setHours(examDate.getHours() + 12)
      const today = new Date()
      const diffInMilliseconds = examDate.getTime() - today.getTime()
      const diffInDays = Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24))
      if (report.passed) {
        return (
          <>
            Congratulations
            <br />
            <span>You've passed this exam!</span>
          </>
        )
      }

      if (diffInDays > 0) {
        return (
          <>
            <DaysBox>
              {diffInDays} days to go {renderStatus()}
            </DaysBox>
            <span>This exam is scheduled: {displayDate}.</span>
          </>
        )
      }

      if (diffInDays === 0) {
        return (
          <>
            How did you do?
            <br />
            <span>Your exam is sheduled for today. Good luck!</span>
          </>
        )
      }

      if (diffInDays < 0) {
        return (
          <>
            How did you do?
            <br />
            <span>
              You took this exam on {displayDate}.
              <br />
              <Link
                to={`/profile/settings/are_progress/${division.toLocaleLowerCase()}`}
              >
                Let us know how you did!
              </Link>
            </span>
          </>
        )
      }
    }

    return <span>Enter your scheduled exam date to start your countdown.</span>
  }

  return (
    <CardBox>
      <CardTitle>
        <span>{division} Exam Status</span>
        <ReportLinkBox>
          <Link
            to={`/profile/settings/are_progress/${division.toLocaleLowerCase()}`}
          >
            Report {division} Results
          </Link>
        </ReportLinkBox>
      </CardTitle>
      <Divider />
      <CardContent>
        <CardText>{renderMessage()}</CardText>
        <IconBox>
          <Link
            to={`/profile/settings/are_progress/${division.toLocaleLowerCase()}`}
          >
            <img src={EditIcon} alt="Edit" />
          </Link>
        </IconBox>
      </CardContent>
    </CardBox>
  )
}

export default View
